export enum EViewKeys {
  emailCapture = "email-capture",
  factorSelector = "factor-selector",
  referenceRanker = "reference-ranker",
  createActionPlan = "create-action-plan",
  contactDetails = "contact-details",
}
